export enum FileTypeEnum {
  Init = 0, // Note: Original had typo "Inıt", corrected to "Init"
  DesignProject = 1,
  CrownJS = 2,
  CrownWasm = 3,
  VeneerJS = 4,
  VeneerWasm = 5,
  UserProfile = 6,
  MachineModelImage = 7,
  BarJS = 8,
  BarWasm = 9,
  CurveFilePoint = 10,
  Product = 11,
  Share = 12,
  Patient = 13,
  WorkOrder = 14,
  ViewerJS = 15,
  ViewerWasm = 16
}
